let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jcGf0")).then(() => parcelRequire('5qlkH'));